export default "__VITE_ASSET__CFAwC8UJ__"